module.exports = __webpack_public_path__ + "static/media/covi_org_bre.48e5fc18.png";